module.exports = __webpack_public_path__ + "img/labour_dept_logo_new.fdad25a9.png";